import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Layout from './Layout';
import { getApiUrl } from './config';

function Dashboard() {
    const [summary, setSummary] = useState({ 
        daily_sale: 0, 
        daily_purchase: 0, 
        total_sale: 0, 
        total_purchase: 0,
        product_count: 0,
        supplier_count: 0,
        customer_count: 0
    });

    useEffect(() => {
        const fetchSummary = async () => {
            try {
                const res = await axios.get(`${getApiUrl()}/dashboard/summary`);
                setSummary(res.data);
            } catch (err) {
                console.error(err);
            }
        };
        fetchSummary();
    }, []);

    return (
        <Layout>
            <div className="container mt-4">
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h2>Dashboard</h2>
                    <span className="badge bg-secondary p-2">Today: {new Date().toLocaleDateString()}</span>
                </div>

                <div className="row">
                    {/* Financial Summary */}
                    <div className="col-md-6 mb-4">
                        <div className="card bg-primary text-white text-center p-4 shadow h-100 border-0">
                            <h5 className="text-uppercase opacity-75">Daily Sale Total</h5>
                            <h1 className="display-4 fw-bold">₹ {(summary.daily_sale || 0).toFixed(2)}</h1>
                            <hr className="bg-white" />
                            <div className="d-flex justify-content-between">
                                <span>Overall Sale:</span>
                                <span className="fw-bold">₹ {(summary.total_sale || 0).toFixed(2)}</span>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 mb-4">
                        <div className="card bg-success text-white text-center p-4 shadow h-100 border-0">
                            <h5 className="text-uppercase opacity-75">Daily Purchase Total</h5>
                            <h1 className="display-4 fw-bold">₹ {(summary.daily_purchase || 0).toFixed(2)}</h1>
                            <hr className="bg-white" />
                            <div className="d-flex justify-content-between">
                                <span>Overall Purchase:</span>
                                <span className="fw-bold">₹ {(summary.total_purchase || 0).toFixed(2)}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row mt-2">
                    {/* Count Summary */}
                    <div className="col-md-4 mb-3">
                        <div className="card border-start border-primary border-4 shadow-sm p-3">
                            <div className="d-flex align-items-center">
                                <div className="flex-grow-1">
                                    <h6 className="text-primary text-uppercase small fw-bold">Total Products</h6>
                                    <h3 className="mb-0">{summary.product_count}</h3>
                                </div>
                                <div className="bg-primary bg-opacity-10 p-3 rounded">
                                    <i className="bi bi-box text-primary fs-3"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 mb-3">
                        <div className="card border-start border-info border-4 shadow-sm p-3">
                            <div className="d-flex align-items-center">
                                <div className="flex-grow-1">
                                    <h6 className="text-info text-uppercase small fw-bold">Suppliers</h6>
                                    <h3 className="mb-0">{summary.supplier_count}</h3>
                                </div>
                                <div className="bg-info bg-opacity-10 p-3 rounded">
                                    <i className="bi bi-truck text-info fs-3"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 mb-3">
                        <div className="card border-start border-warning border-4 shadow-sm p-3">
                            <div className="d-flex align-items-center">
                                <div className="flex-grow-1">
                                    <h6 className="text-warning text-uppercase small fw-bold">Customers</h6>
                                    <h3 className="mb-0">{summary.customer_count}</h3>
                                </div>
                                <div className="bg-warning bg-opacity-10 p-3 rounded">
                                    <i className="bi bi-people text-warning fs-3"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row mt-4">
                    <div className="col-md-12">
                        <div className="card p-4 border-0 shadow-sm">
                            <h4 className="border-bottom pb-2 mb-3">Quick Navigation</h4>
                            <div className="row g-2">
                                <div className="col-6 col-md-3">
                                    <button className="btn btn-outline-primary w-100 py-3" onClick={() => window.location.href='/sale'}>New Sale</button>
                                </div>
                                <div className="col-6 col-md-3">
                                    <button className="btn btn-outline-success w-100 py-3" onClick={() => window.location.href='/purchase'}>New Purchase</button>
                                </div>
                                <div className="col-6 col-md-3">
                                    <button className="btn btn-outline-info w-100 py-3" onClick={() => window.location.href='/reports/sale'}>Sales Report</button>
                                </div>
                                <div className="col-6 col-md-3">
                                    <button className="btn btn-outline-dark w-100 py-3" onClick={() => window.location.href='/reports/stock'}>Stock Report</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
}

export default Dashboard;